module.exports = __webpack_public_path__ + "img/20240901_3.1d0de441.jpg";